import React from 'react';
import styled from 'styled-components';
import {
  TextField,
  MenuItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';
import {
  ViewStream as ViewStreamIcon,
  AccountTree as AccountTreeIcon,
  RadioButtonChecked as RadioButtonCheckedIcon
} from '@material-ui/icons';
import { StateNodeType } from '@sierralabs/workflow';

const Styled = {
  MenuItemContent: styled.div`
    display: flex;
    align-items: center;
    .MuiListItemIcon-root {
      min-width: auto;
      margin-right: 16px;
    }
  `
};

const options = [
  {
    title: 'Normal State',
    type: StateNodeType.Atomic,
    icon: <AccountTreeIcon />
  },
  {
    title: 'Parallel State',
    type: StateNodeType.Parallel,
    icon: <ViewStreamIcon />
  },
  {
    title: 'Final State',
    type: StateNodeType.Final,
    icon: <RadioButtonCheckedIcon />
  }
];

export interface StateNodeTypeSelectorProps {
  type?: StateNodeType;
  onChange?: (type: StateNodeType) => void;
}

const StateNodeTypeSelector: React.FC<StateNodeTypeSelectorProps> = (
  props: StateNodeTypeSelectorProps
) => {
  const { type, onChange } = props;
  return (
    <TextField
      select
      fullWidth
      size='small'
      className='field'
      variant='outlined'
      label='State Type'
      value={type || ''}
      onChange={event => {
        let value = event.target.value as StateNodeType;
        if (value) {
          value = value === StateNodeType.Atomic ? StateNodeType.Auto : value;
          onChange?.(value);
        }
      }}
    >
      {options.map(({ title, type, icon }) => (
        <MenuItem key={type} value={type}>
          <Styled.MenuItemContent>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={title} />
          </Styled.MenuItemContent>
        </MenuItem>
      ))}
    </TextField>
  );
};

export default StateNodeTypeSelector;
